<template>
  <v-container fluid>
    <div class="receipt">
      <div class="paper">
        <dl>
          <dt>Fecha de abono: {{ objetoDatosAbonoSencillo.Fecha }}</dt>
          <dd>#REF: {{ objetoDatosAbonoSencillo.IdEnvio }}</dd>
        </dl>
        <div style="text-align:center;">
          <span><<<<<<< ABONO DEUDA ENVIO >>>>>>>>></span><br>
          Nombre de cliente: {{nombreAbonante}}
        </div>
        
        <dl class="total">
          <dt>Deuda total envío:</dt>
          <dd>{{ formateaMoneda(objetoDatosAbonoSencillo.ObjTotales.CostoEnvio) }}</dd>
        </dl>
        <dl class="total">
          <dt>Monto abonado:</dt>
          <dd>{{ formateaMoneda(objetoDatosAbonoSencillo.ObjTotales.Abono) }}</dd>
        </dl>
        <dl class="total">
          <dt>Total abonado:</dt>
          <dd>{{ formateaMoneda(objetoDatosAbonoSencillo.ObjTotales.SumAbonos) }}</dd>
        </dl>
        <dl class="total">
          <dt>Deuda total actual:</dt>
          <dd>{{ formateaMoneda(objetoDatosAbonoSencillo.ObjTotales.DeudaEnvio) }}</dd>
        </dl>
        <dl class="total">
          <dt>Cambio entregado:</dt>
          <dd>{{ formateaMoneda(objetoDatosAbonoSencillo.ObjTotales.Cambio) }}</dd>
        </dl>
        <br />

        <dl>
          <dt>
            Autoriza:
          </dt>
          <dd>
            {{ logedInUserInfo.nombre }}
          </dd>
        </dl>
        ______________________________________
        <hr />
      </div>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
export default {
  async beforeMount() {
    await this.getSucursalEnLaQueEstoy(this.logedInUserInfo.sucursal);
  },
  computed: {
    ...mapState("enviosInfoEnvio", {
      infoEnvioActual: state => state.infoEnvio,
      infoEnvioGeneradaDespues: state => state.infoEnvioGeneradaDespues
    }),
    ...mapState("sesion", {
      sucursalInfo: state => state.sucursalData,
      logedInUserInfo: state => state.logedInUserInfo
    }),
    ...mapState("abonosEnvios", {
      objetoDatosAbonoSencillo: state => state.objetoDatosAbonoSencillo,
      objetoDatosMultiple: state => state.objetoDatosMultiple,
      objetoDatosCambioDireccion: state => state.objetoDatosCambioDireccion,
      nombreAbonante: state => state.nombreAbonante
    })
  },
  methods: {
    ...mapActions("sesion", ["getSucursalEnLaQueEstoy"]),
    formateaMoneda(moneda){
      return FormatoMoneda.format(moneda);
    }
  }
};
</script>
<style lang="css" scoped>
* {
   font-size: 18px/1.5;
   font-family: 'Lato', sans-serif;
  box-sizing: border-box;
  align-items: left;
  letter-spacing: -1px;
  line-height: 0.9;
}
body {
  display: flex;
  height: 100vh;
  margin: 0;
  justify-content: center;
  align-items: left;
  font-size: 12px;
}
.receipt {
  align-items: left;
  word-break: break-word;
  width: 302px;
  border: 1px dotted black;
  border-width: 1px 0;
}
.receipt .paper {
  background: white;
  text-align: left;
}
.receipt h1 {
  font-size: 150%;
  margin: 0;
}
.receipt h1,
.receipt .event {
  text-align: center;
  line-height: 1;
}
.receipt dl {
  display: flex;
  flex-wrap: wrap;
  margin: 1.5em 0 0;
}
.receipt dt,
.receipt dd {
  margin: 0;
  width: 50%;
}
.receipt dd {
  text-align: right;
}
.receipt .total {
  margin: 0;
}
.receipt .total:before {
  display: block;
  width: 100%;
  text-align: right;
}
.receipt .total dt {
  text-align: right;
}
.receipt .total dd {
  padding-left: 0.5em;
  text-align: left;
}
</style>
